<template>
    <div>
        <div style="text-align: left;">
            <el-form size="mini">
                <el-form-item>
                    <el-button type="primary" @click="addData">添加</el-button>
                </el-form-item>
            </el-form>
        </div>
        <el-table :data="tableData" border style="width: 100%;text-align: center;" :default-expand-all="false" row-key="id">
            <el-table-column prop="field1" label="字段1" width="180">
            </el-table-column>
            <el-table-column prop="field2" label="字段2" width="180">
            </el-table-column>
            <el-table-column prop="field3" label="字段3" width="180">
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button size="mini" type="success" @click="editData(scope.row)">编辑</el-button>
                    <el-button size="mini" type="warning" @click="delData(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div>
            <el-dialog :title="dialogTitle" :visible.sync="dialogShow" width="30%">
                <edit-vue ref="dialog" @callMethod="getData"></edit-vue>
            </el-dialog>
        </div>
    </div>
</template>

<script>
// import EditVue from '@/components/xxx.vue'
export default {
    name: 'xxxXxx',
    components: {
        // EditVue
    },
    created() { },
    data() {
        return {
            dialogTitle: '',
            dialogShow: false,
            tableData: [],
        }
    },
    methods: {
        getData() { },
        addData() {
            this.dialogTitle = '添加'
            this.dialogShow = true
        },
        editData() {
            this.dialogTitle = '编辑'
            this.dialogShow = true
        },
        delData() { }
    }
}
</script>
